import React from 'react';

const JSON_Objects = () => {
  return (
    <div >
      <h1>JSON_Objects</h1>
      <p>Placeholder component for: "JSON Objects"</p>
    </div>
  );
};

export default JSON_Objects;
